import React from 'react';

interface ProfileIconProps {
  isActive?: boolean;
  className?: string;
}

const ProfileIcon: React.FC<ProfileIconProps> = ({ isActive = false, className = 'mr-2' }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    className={className} 
    width="18" 
    height="18" 
    viewBox="0 0 24 24" 
    fill="none" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path 
      d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" 
      stroke={isActive ? "#4F46E5" : "#4B5563"}
      fill={isActive ? "#EEF2FF" : "none"}
    />
    <circle 
      cx="12" 
      cy="7" 
      r="4" 
      stroke={isActive ? "#4F46E5" : "#4B5563"}
      fill={isActive ? "#EEF2FF" : "none"}
    />
  </svg>
);

export default ProfileIcon;
